import { Component, EventEmitter, OnDestroy, Output } from "@angular/core";
import { AuthService } from "../../services/auth.service";
import { environment } from "src/environments/environment";

@Component({
    selector: "app-rayalina-social-login",
    templateUrl: "./social-login.component.html",
    styleUrls: ["./social-login.component.scss"],
})
export class RayalinaSocialLoginComponent implements OnDestroy {
    @Output() readonly success = new EventEmitter<void>();

    readonly enabled = environment.enableSocialLogin && !!environment.apiUrl;

    private messageHandler = (event: MessageEvent) => {
        try {
            const data = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
            if (data?.accessToken) {
                this.auth.saveAuth(data);
                this.success.emit();
            }
        } catch {
            /* ignore non-auth post messages */
        }
    };

    constructor(private readonly auth: AuthService) {
        if (this.enabled) {
            window.addEventListener("message", this.messageHandler);
        }
    }

    ngOnDestroy(): void {
        window.removeEventListener("message", this.messageHandler);
    }

    loginGoogle(): void {
        this.openOAuth(`${environment.apiUrl}/auth/google`);
    }

    loginFacebook(): void {
        this.openOAuth(`${environment.apiUrl}/auth/facebook`);
    }

    private openOAuth(url: string): void {
        window.open(url, "_blank", "width=800,height=600,top=100,left=100");
    }
}
